<script setup lang="ts">
/**
 * @description UI-kit icon component — FontAwesome icon in a sized container
 * @category UI / Icons
 * @figma https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=6071-154424
 */
import type { AppIconProps } from '../types/interfaces'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { useAppIcon } from '../composables/use-app-icon.hook'

defineOptions({
  name: 'AppIcon',
})

const props = withDefaults(defineProps<AppIconProps>(), {
  size: 'big',
  color: undefined,
})

const { classList } = useAppIcon({ props })
</script>

<template>
  <span :class="classList">
    <FontAwesomeIcon :icon="icon" />
  </span>
</template>

<style scoped lang="scss" src="../styles/_app-icon.scss" />
